import { Archive } from './pages/archive'
import { ArchiveQDN } from './pages/archive_qdn'
import { Inspi } from './pages/inspi'
import { Single } from './pages/single'
import { List } from './pages/list'
import { Centre } from './pages/centre'
import { Media } from './pages/media'
import { Contact } from './pages/contact'
import { Search } from './pages/search'
import { Divertissement } from './pages/divertissement'
import { Home } from './pages/home'
import { Nav } from './components/nav'
import { ScrollAnime } from './components/scrollAnime'
import { Horaire } from './components/horaire'

class App {
  constructor() {
    const nav = new Nav;
    const scrollAnime = new ScrollAnime;

    if(document.querySelector('.axios_horaire')) {
      const horaire = new Horaire;
    }

    if(document.querySelector('body.home')) {
      const home = new Home;
    }

    if(document.querySelector('.archive-shopping') || document.querySelector('.archive-fooding')) {
      const archive = new Archive;
    }

    if(document.querySelector('.template-single:not(.post-qdn)')) {
      const single = new Single;
    }

    if(document.querySelector('.archive-divert')) {
      const single = new Divertissement;
    }

    if(document.querySelector('.archive-qdn')) {
      const archive_qdn = new ArchiveQDN;
    }

    if(document.querySelector('.template-qdn-inspi')) {
      const inspi = new Inspi;
    }

    if(document.querySelector('.template-list')) {
      const list = new List;
    }

    if(document.querySelector('.template-centre')) {
      const centre = new Centre;
    }

    if(document.querySelector('.template-contact')) {
      const contact = new Contact;
    }

    if(document.querySelector('.template-media')) {
      const media = new Media;
    }

    if(document.querySelector('.template-search')) {
      const search = new Search;
    }
  }
}

window.onload = function() {
  let app = new App();
};
